// ─────────────────────────────────────────────────────────────────────────
//  ClickViewer · web · 「DB 가 허락한다」와 「이 앱에 그 길이 있다」는 다르다
//
//  ★★ `perms[]` 는 **DB 의 대답**이다. 라우트가 있다는 뜻이 아니다.
//
//    구체적으로: 조직 관리자에게는 `project.delete` 가 **true 로 온다**
//    (`can()` 이 org_member 로 통과시킨다 — 003:36). 그런데 그 라우트는 이 앱에 없다.
//    `soft_delete_project` 는 008:369-385 가 app_api 에서 revoke 해서 `app_admin`
//    롤로 옮겼고, 그 롤은 두 번째 Hyperdrive 바인딩이 필요한데 Cloudflare 계정이
//    아직 없다. 즉 **버튼을 그리면 눌러서 실패한다.**
//
//    "그러니 그 버튼만 안 그리면 된다" 로 끝내면, 다음 사람이 다음 권한으로 같은 버그를
//    다시 만든다. 문서 경고가 아니라 **상수 하나로** 막는다.
//
//  ⚠️ 라우트를 새로 만들 때마다 여기 한 줄을 같이 추가해라. 안 하면 버튼이 안 뜨는데,
//     그건 "눌렀더니 실패" 보다 훨씬 빨리 발견된다(만든 사람이 바로 본다).
// ─────────────────────────────────────────────────────────────────────────

/** 이 앱에 **실제로 라우트가 있는** 권한 키. */
export const IMPLEMENTED: ReadonlySet<string> = new Set([
  'project.view',
  'project.manage',
  'member.view',
  'member.invite',
  'member.manage',
  'module.view',
  'module.manage', // `/{slug}/modules` — screens/admin/Modules.tsx
  'upload.view', //   `/{slug}/upload`  — screens/Upload.tsx
  'upload.create',
  'upload.abort',
  'trash.view', //    `/{slug}/trash`   — screens/admin/Trash.tsx
  'trash.restore',
  'trash.delete',
  'share.view', //    `/{slug}/share`   — screens/admin/Share.tsx
  'share.create',
  'share.revoke',
  // ★ [025] `/{slug}/alignments` — screens/admin/Alignments.tsx
  //   ⚠️ **읽기 키가 `model.view` 다.** 선형만의 권한 키를 새로 만들지 않았다 —
  //      `db/002_catalog.sql` 은 로컬과 Azure 에 이미 적용됐고, 거기 줄을 더하면
  //      두 DB 가 갈라진다(012·017 이 같은 판단을 적어 뒀다). 올리기는 `upload.create` 다.
  'model.view',
  // ── 아직 없는 것들 (있으면 안 되는 이유를 같이 남긴다) ──
  // 'project.delete' — app_admin 롤이 필요하다. 계정이 생기기 전에는 그릴 수 없다
  //                    (008 이 soft_delete_project 를 app_api 에서 회수했다)
  // 'project.restore'— 위와 같다
  // 'audit.view'     — 이력 화면 없음
]);

/**
 * 화면에 그려도 되는가.
 *
 * `perms.includes(k)` 를 직접 쓰지 마라. **교집합만 그린다.**
 */
export function can(perms: readonly string[] | undefined, key: string): boolean {
  return !!perms && perms.includes(key) && IMPLEMENTED.has(key);
}
